import React from 'react';

import PanelSelect from '../panel-select/panel-select';

import './datepicker-top-action-panel.scss';

const months = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
];

const getYearsArr = () => {
  const max = new Date().getFullYear();
  const min = max - 30;
  const result = [];

  for (let i = max; i > min; i -= 1) {
    result.push({
      label: i.toString(),
      value: i.toString(),
    });
  }

  return result;
};

interface DatepickerTopActionPanelProps {
  selectedStartMonth?: number;
  selectedStartYear?: number;
  selectedEndMonth?: number;
  selectedEndYear?: number;
  onStartMonthChange: (year: number, month: number) => void;
  onStartYearChange: (year: number, month: number) => void;
  onEndMonthChange: (year: number, month: number) => void;
  onEndYearChange: (year: number, month: number) => void;
}

const DatepickerTopActionPanel: React.FC<DatepickerTopActionPanelProps> = ({
  onEndMonthChange,
  onEndYearChange,
  onStartMonthChange,
  onStartYearChange,
  selectedEndMonth,
  selectedEndYear,
  selectedStartMonth,
  selectedStartYear,
}) => (
  <div className="datepicker-top-action-panel">
    <div className="datepicker-top-action-panel__left datepicker-top-action-panel__item">
      <div className="select-container">
        <PanelSelect
          selected={
            selectedStartMonth !== undefined
              ? selectedStartMonth.toString()
              : undefined
          }
          options={months.map((month, index) => ({
            label: month,
            value: index.toString(),
          }))}
          onOptionSelect={(val) => {
            if (selectedStartYear) {
              onStartMonthChange(selectedStartYear, parseInt(val, 10));
            }
          }}
        />
      </div>
      <div className="select-container">
        <PanelSelect
          selected={
            selectedStartYear ? selectedStartYear.toString() : undefined
          }
          options={getYearsArr()}
          onOptionSelect={(val) => {
            if (selectedStartMonth) {
              onStartYearChange(parseInt(val, 10), selectedStartMonth);
            } else {
              onStartYearChange(parseInt(val, 10), 1);
            }
          }}
        />
      </div>
    </div>
    <div className="datepicker-top-action-panel__right datepicker-top-action-panel__item">
      <div className="select-container">
        <PanelSelect
          selected={selectedEndMonth ? selectedEndMonth.toString() : undefined}
          options={months.map((month, index) => ({
            label: month,
            value: index.toString(),
          }))}
          onOptionSelect={(val) => {
            if (selectedEndYear) {
              onEndMonthChange(selectedEndYear, parseInt(val, 10));
            }
          }}
        />
      </div>
      <div className="select-container">
        <PanelSelect
          selected={selectedEndYear ? selectedEndYear.toString() : undefined}
          options={getYearsArr()}
          onOptionSelect={(val) => {
            if (selectedEndMonth) {
              onEndYearChange(parseInt(val, 10), selectedEndMonth);
            } else {
              onStartYearChange(parseInt(val, 10), 1);
            }
          }}
        />
      </div>
    </div>
  </div>
);

export default DatepickerTopActionPanel;
